import * as Color from 'color';

const updateLottieColor = (json: Object, color: String, name: String | null = null): Object | undefined => {
  const obj = JSON.parse(JSON.stringify(json));
  const colorObj = Color(color);

  return findAndUpdateBrandedColor(obj, name, colorObj);
};

const findAndUpdateBrandedColor = (json: Object, name: String | null, color: Color): object | undefined => {
  if (!json || typeof json === 'boolean' || typeof json === 'string' || typeof json === 'number') {
    return;
  }

  const keys = Object.keys(json);

  if (keys.length == 0) {
    return;
  }

  keys.forEach((key) => {
    let didReplace = false;
    if (key === 'ty' && (json[key] === 'fl' || json[key] === 'st')) {
      didReplace = replaceColorIfNeeded(json, name, color);
    }

    if (!didReplace) findAndUpdateBrandedColor(json[key], name, color);
  });

  return json;
};

const replaceColorIfNeeded = (json: any, name: String | null, color: Color): boolean => {
  let rgb = color.rgb();
  if (json.nm && (json.nm === name || !name)) {
    if (json.c && json.c.k) {
      json.c.k = [rgb.color[0] / 255, rgb.color[1] / 255, rgb.color[2] / 255, color.valpha];

      return true;
    }
  }

  return false;
};

export default updateLottieColor;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/styling/updateLottieColor.ts